'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _commonActivities = require('../common-activities');

var _constants = require('../../constants');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var EMPTY_FIELD = _constants.AppConstants.EMPTY_FIELD;
var getNameOrDefault = _utils.FormattingUtils.getNameOrDefault,
    formatDate = _utils.FormattingUtils.formatDate,
    formatMoney = _utils.FormattingUtils.formatMoney;

var EMPTY_FIELD_DIV = _react2.default.createElement(
  'div',
  null,
  EMPTY_FIELD
);

var CaseSearchResultItem = (0, _classAutobindDecorator2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseSearchResultItem, _Component);

  function CaseSearchResultItem() {
    _classCallCheck(this, CaseSearchResultItem);

    return _possibleConstructorReturn(this, (CaseSearchResultItem.__proto__ || Object.getPrototypeOf(CaseSearchResultItem)).apply(this, arguments));
  }

  _createClass(CaseSearchResultItem, [{
    key: 'onItemClick',
    value: function onItemClick() {
      var _props = this.props,
          onItemClick = _props.onItemClick,
          item = _props.item;

      onItemClick(item.id);
    }
  }, {
    key: 'renderApplicationStatusCell',
    value: function renderApplicationStatusCell() {
      var item = this.props.item,
          isOpenField = (0, _get3.default)(item, 'lien_summary.is_open'),
          isClosed = !isOpenField && isOpenField !== null;


      if (!item.last_application) {
        return EMPTY_FIELD_DIV;
      }

      return _react2.default.createElement(
        'div',
        { className: 'two-line-cell' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'strong',
            null,
            isClosed ? 'Closed' : item.last_application.status
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Created: ',
            formatDate(item.last_application.created_at)
          )
        )
      );
    }
  }, {
    key: 'renderLienSummaryCell',
    value: function renderLienSummaryCell() {
      var item = this.props.item;


      if (!(item.lien_summary && item.lien_summary.total_number_of_liens > 0)) {
        return EMPTY_FIELD_DIV;
      }

      return _react2.default.createElement(
        'div',
        { className: 'two-line-cell' },
        _react2.default.createElement(
          'div',
          null,
          formatMoney(item.lien_summary.total_principal_amount_of_liens),
          ' ',
          '(',
          item.lien_summary.total_number_of_liens,
          ')'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Last Agreement Date: ',
            formatDate(item.lien_summary.latest_agreement_date)
          )
        )
      );
    }
  }, {
    key: 'renderReturnSummaryCell',
    value: function renderReturnSummaryCell() {
      var item = this.props.item;


      if (!(item.lien_summary && item.lien_summary.total_number_of_returns > 0)) {
        return EMPTY_FIELD_DIV;
      }

      return _react2.default.createElement(
        'div',
        { className: 'two-line-cell' },
        _react2.default.createElement(
          'div',
          null,
          formatMoney(item.lien_summary.total_actual_amount_of_returns)
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Returned On: ',
            formatDate(item.lien_summary.latest_matured_date)
          )
        )
      );
    }
  }, {
    key: 'renderLastActivity',
    value: function renderLastActivity() {
      var item = this.props.item;


      if (!item.last_activity) {
        return _react2.default.createElement(
          'div',
          { className: 'empty' },
          'No activity'
        );
      }

      return _react2.default.createElement(_commonActivities.Activity, { activity: item.last_activity, size: 'normal', truncateBody: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          item = _props2.item,
          fieldUserSearchedBy = _props2.fieldUserSearchedBy;


      return _react2.default.createElement(
        'tr',
        { key: item.id, onClick: this.onItemClick, className: 'tr-clickable' },
        _react2.default.createElement(
          'td',
          { className: 'fs-mask' },
          getNameOrDefault(item.plaintiff)
        ),
        _react2.default.createElement(
          'td',
          null,
          getNameOrDefault(fieldUserSearchedBy === 'attorney' ? item.lawfirm : item.attorney)
        ),
        _react2.default.createElement(
          'td',
          null,
          this.renderApplicationStatusCell()
        ),
        _react2.default.createElement(
          'td',
          null,
          this.renderLienSummaryCell()
        ),
        _react2.default.createElement(
          'td',
          null,
          this.renderReturnSummaryCell()
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-last-activity' },
          this.renderLastActivity()
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseSearchResultItem;
}(_react.Component), _class2.propTypes = {
  fieldUserSearchedBy: _propTypes2.default.string,
  item: _propTypes2.default.shape({
    attorney: _propTypes2.default.object,
    id: _propTypes2.default.string,
    last_activity: _propTypes2.default.object,
    last_application: _propTypes2.default.object,
    lawfirm: _propTypes2.default.object,
    lien_summary: _propTypes2.default.object,
    plaintiff: _propTypes2.default.object
  }).isRequired,
  onItemClick: _propTypes2.default.func.isRequired
}, _temp)) || _class;

var _default = CaseSearchResultItem;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(EMPTY_FIELD, 'EMPTY_FIELD', '/app/src/components/page-case-search-results/CaseSearchResultItem.js');
  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/page-case-search-results/CaseSearchResultItem.js');
  reactHotLoader.register(formatDate, 'formatDate', '/app/src/components/page-case-search-results/CaseSearchResultItem.js');
  reactHotLoader.register(formatMoney, 'formatMoney', '/app/src/components/page-case-search-results/CaseSearchResultItem.js');
  reactHotLoader.register(EMPTY_FIELD_DIV, 'EMPTY_FIELD_DIV', '/app/src/components/page-case-search-results/CaseSearchResultItem.js');
  reactHotLoader.register(CaseSearchResultItem, 'CaseSearchResultItem', '/app/src/components/page-case-search-results/CaseSearchResultItem.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-search-results/CaseSearchResultItem.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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